export default "__VITE_ASSET__4jDg5Qn5__"